import { MoreHorizontal } from "lucide-react";
import type { ActionAvailability } from "@amber/contracts";
import { Button, MenuContent, MenuItem, MenuRoot, MenuTrigger } from "@amber/ui";
import type { SourceRow } from "../../contracts/index";

export function SourceRowMenu({
  row,
  edit,
  onEdit,
}: {
  row: SourceRow;
  edit: ActionAvailability;
  onEdit: (id: string) => void;
}) {
  return (
    <MenuRoot>
      <MenuTrigger asChild>
        <Button size="sm" variant="ghost" aria-label={`Actions for ${row.title}`}>
          <MoreHorizontal size={14} aria-hidden="true" />
        </Button>
      </MenuTrigger>
      <MenuContent className="w-[300px]">
        <MenuItem
          disabled={!edit.enabled}
          className="flex-col items-start gap-0"
          onSelect={() => {
            onEdit(row.id);
          }}
        >
          <span>Edit source…</span>
          <small className="text-sm text-muted">
            {edit.enabled ? "Name, people and plans, cadence, known breaks, quota group" : edit.reason}
          </small>
        </MenuItem>
      </MenuContent>
    </MenuRoot>
  );
}
